import { JSX } from 'preact';

/**
 * Small flags for the campaign currency switch. Drawn as SVG rather than flag
 * emoji: Windows has no flag emoji and shows the bare letters "US" / "CA".
 * A currency with no flag here shows its code alone.
 */

const usStripes = Array.from({ length: 13 }, (_, i) => i);
const usStars = Array.from({ length: 9 }, (_, row) =>
  Array.from({ length: row % 2 ? 5 : 6 }, (_, col) => ({
    cx: 247 + col * 494 + (row % 2 ? 247 : 0),
    cy: 210 + row * 210,
  })),
).flat();

function UsFlag() {
  return (
    <svg viewBox="0 0 7410 3900" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
      {usStripes.map((i) => (
        <rect key={i} y={i * 300} width="7410" height="300" fill={i % 2 ? '#fff' : '#b22234'} />
      ))}
      <rect width="2964" height="2100" fill="#3c3b6e" />
      {usStars.map((s) => (
        <circle key={`${s.cx}-${s.cy}`} cx={s.cx} cy={s.cy} r="80" fill="#fff" />
      ))}
    </svg>
  );
}

function CaFlag() {
  return (
    <svg viewBox="0 0 9600 4800" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
      <path fill="#d52b1e" d="m0 0h2400l99 99h4602l99-99h2400v4800h-2400l-99-99h-4602l-99 99H0z" />
      <path
        fill="#fff"
        d="m2400 0h4800v4800h-4800zm2490 4430-45-863a95 95 0 0 1 111-98l859 151-116-320a65 65 0 0 1 20-73l941-762-212-99a65 65 0 0 1-34-79l186-572-542 115a65 65 0 0 1-73-38l-105-247-423 454a65 65 0 0 1-111-57l204-1052-327 189a65 65 0 0 1-91-27l-332-652-332 652a65 65 0 0 1-91 27l-327-189 204 1052a65 65 0 0 1-111 57l-423-454-105 247a65 65 0 0 1-73 38l-542-115 186 572a65 65 0 0 1-34 79l-212 99 941 762a65 65 0 0 1 20 73l-116 320 859-151a95 95 0 0 1 111 98l-45 863z"
      />
    </svg>
  );
}

const flags: Record<string, () => JSX.Element> = {
  USD: UsFlag,
  CAD: CaFlag,
};

export function CurrencyFlag({ currency }: { currency: string }) {
  const Flag = flags[currency.toUpperCase()];
  if (!Flag) {
    return undefined;
  }
  return (
    <span class="currency-flag">
      <Flag />
    </span>
  );
}
